module.exports = __webpack_public_path__ + "images/hero-glitches.png";